import { StatuteStatistic } from '../types/StatuteStatistics.type';

const NON_RACE_PREFIX = 'Non-';

export interface StatuteStatisticsFilters {
  stageName?: string | null;
  raceName?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
}

function dateToYearMonth(date: Date): number {
  return date.getFullYear() * 100 + (date.getMonth() + 1);
}

function matchesRaceFilter(entryRace: string, raceName: string): boolean {
  if (raceName.startsWith(NON_RACE_PREFIX)) {
    const excludedRace = raceName.slice(NON_RACE_PREFIX.length);
    return entryRace !== excludedRace;
  }
  return entryRace === raceName;
}

export function countStatuteStatistics(
  statistics: StatuteStatistic[],
  filters: StatuteStatisticsFilters,
  countField: 'cases_count' | 'case_charges_count' = 'cases_count',
): number {
  return statistics
    .filter((entry) => {
      if (filters.stageName != null) {
        if (entry.stage !== filters.stageName) return false;
      } else {
        if (entry.stage !== null) return false;
      }

      if (filters.raceName != null && !matchesRaceFilter(entry.race, filters.raceName)) return false;

      if (filters.startDate != null && entry.year_month < dateToYearMonth(filters.startDate)) return false;

      if (filters.endDate != null && entry.year_month > dateToYearMonth(filters.endDate)) return false;

      return true;
    })
    .reduce((sum, entry) => sum + entry[countField], 0);
}
